/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Box, Container, Grid, Typography, Card } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import FileUpload from '../../components/file-upload/fileUpload';

export default function NvStreamerFileUpload() {
  const location = useLocation();
  return (
    <div
      style={{
        display: location.pathname === '/streamer/file-upload' ? 'inline' : 'none',
      }}
    >
      <Helmet>
        <title> {location.pathname === '/streamer/file-upload' ? 'File upload' : 'Streaming'} </title>
      </Helmet>
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          File upload
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <Box sx={{ p: 3 }}>
                <FileUpload />
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
